export default "__VITE_ASSET__d0eb472a__"